var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgBook = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("rect", {
    width: 55,
    height: 64.453,
    x: 20,
    y: 16,
    fill: "var(--color-neutral-70)",
    rx: 4.4
  }), React.createElement("rect", {
    width: 44.621,
    height: 2.479,
    x: 24.958,
    y: 71.236,
    fill: "var(--color-neutral-90)",
    rx: 1.239
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M74.537 75.985v0c0 2.468-2 4.468-4.468 4.468H24.9a4.9 4.9 0 0 1-4.9-4.9V20.9a4.9 4.9 0 0 1 4.9-4.9h44.737a4.9 4.9 0 0 1 4.9 4.9v45.717a4.9 4.9 0 0 1-4.9 4.9h-42.61c-.937 0-2.81.503-2.81 2.389 0 1.886 1.405 2.53 2.81 2.53h40.76"
  }), React.createElement("path", {
    fill: color,
    stroke: color,
    strokeWidth: 1.5,
    d: "M34.474 41.637v-24.19h7.237v24.19a.2.2 0 0 1-.325.156l-3.169-2.535a.2.2 0 0 0-.25 0L34.8 41.793a.2.2 0 0 1-.325-.156Z"
  }), React.createElement("rect", {
    width: 1.405,
    height: 37.948,
    x: 25.622,
    y: 25.839,
    fill: color,
    stroke: color,
    strokeWidth: 0.5,
    rx: 0.703
  }));
};
export default SvgBook;